var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.apparatusesToAdd &&
    _vm.apparatusesToAdd.length &&
    _vm.subscriptionProduct
    ? _c(
        "b-card-group",
        {
          staticClass: "mx-lg-2",
          attrs: { id: "subscription-upgrade-card", deck: "" }
        },
        [
          _c(
            "b-card",
            {
              class: `paid-subs-info-card mb-0 sub-card mx-1 ${
                _vm.isHighlighted ? "new" : "current"
              }`,
              attrs: {
                "body-class": "subs-info-card-body",
                "data-test-hook": "upgrade-subscription-card"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "plan-header",
                            attrs: { "data-test-hook": "upgrade-plan-header" }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.subscriptionProduct.name) + " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2360357942
              )
            },
            [
              _vm.annualPaidProduct && _vm.monthlyPaidProduct
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("CadenceSelectionTabs", {
                            attrs: {
                              "annual-paid-product": _vm.annualPaidProduct,
                              "monthly-paid-product": _vm.monthlyPaidProduct,
                              "selected-product": _vm.subscriptionProduct
                            },
                            on: { setSelectedProduct: _vm.setSelectedProduct }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-row",
                { staticClass: "align-items-center mb-2 mx-0" },
                [
                  !_vm.hideBadge
                    ? _c(
                        "b-col",
                        { staticClass: "px-0" },
                        [
                          _vm.isNewPlan
                            ? _c(
                                "b-badge",
                                {
                                  staticClass: "plan-badge",
                                  attrs: {
                                    variant: "primary",
                                    "data-test-hook":
                                      "upgrade-subscription-card-new-plan-badge"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("xNewPlan")))]
                              )
                            : _c(
                                "b-badge",
                                {
                                  staticClass:
                                    "border-primary text-primary plan-badge",
                                  attrs: {
                                    variant: "light",
                                    "data-test-hook":
                                      "upgrade-subscription-card-current-plan-badge"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("xCurrentPlan")))]
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("b-col", { staticClass: "px-0 price" }, [
                    _c(
                      "h1",
                      {
                        staticClass: "mb-0 pb-0",
                        class: _vm.hideBadge ? "solo-price" : "",
                        attrs: {
                          "data-test-hook": "upgrade-subscription-card-cost"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatCurrency")(
                                _vm.subscriptionProduct.cost
                              )
                            )
                        ),
                        _c("span", { staticClass: "duration-label" }, [
                          _vm._v(" /" + _vm._s(_vm.durationLabel))
                        ]),
                        _vm.hideBadge &&
                        _vm.annualPaidProduct &&
                        _vm.subscriptionProduct.productId ===
                          _vm.annualPaidProduct.productId
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "plan-badge ml-2 align-middle",
                                attrs: {
                                  variant: "primary",
                                  "data-test-hook": "subscription-savings-badge"
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("xSavePercent")) + " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "subscriptionCardText" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.subscriptionProduct &&
                        _vm.subscriptionProduct.description
                          ? _c(
                              "strong",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "existing-subscription-modal-premium-monitoring-max-products-text"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.subscriptionProduct.description
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._l(_vm.existingApparatuses, function(apparatus, index) {
                    return _c(
                      "b-row",
                      { key: `current-${index}` },
                      [
                        _c("b-col", { staticClass: "mt-2" }, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("i", {
                              staticClass:
                                "fas fa-fw fa-check-circle check-icon mr-2"
                            }),
                            _c("p", [_vm._v(_vm._s(apparatus.name))])
                          ])
                        ])
                      ],
                      1
                    )
                  }),
                  _vm._l(_vm.apparatusesToAdd, function(apparatus, index) {
                    return _c(
                      "b-row",
                      { key: `new-${index}` },
                      [
                        apparatus.type === 0 || apparatus.apparatusType === 0
                          ? _c("ExpandableHsbSubscriptionFeaturesList", {
                              attrs: {
                                id: `${apparatus.apparatusId}-${
                                  _vm.isNewPlan ? "current" : "new"
                                }`,
                                "generator-name": apparatus.name,
                                "is-covered": _vm.isNewPlan || _vm.areAllCovered
                              }
                            })
                          : apparatus.type === 2 ||
                            apparatus.apparatusType === 2
                          ? _c("ExpandableTankSubscriptionFeaturesList", {
                              attrs: {
                                id: `${apparatus.apparatusId}-${
                                  _vm.isNewPlan ? "current" : "new"
                                }`,
                                "tank-name": apparatus.name,
                                "is-covered": _vm.isNewPlan || _vm.areAllCovered
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }